import { SIZE_FULL } from '@/lib/gridElements/size';

import AnalyticsTable from '@/components/composite/Tables/AnalyticsTable';

export const tagUsageTableConfig = {
    title: 'tabs.instagram.tag_usage_table.title',
    title_head: 'tabs.instagram.tag_usage_table.title_head',
    id: 'tag_usage_organic',
    columnNames: {
        hashtag: 'tabs.instagram.tag_usage_table.hashtag',
        utilisation: 'tabs.instagram.tag_usage_table.utilisation',
        user: 'tabs.instagram.tag_usage_table.most_used_by',
        average_engagement_rate_per_post:
            'tabs.instagram.tag_usage_table.average_engagement_rate_per_post'
    },
    size: SIZE_FULL,
    sortBy: {
        id: 'utilisation',
        desc: true
    },
    type: 'table',
    tooltip: 'analytics:tabs.instagram.tag_usage_table.tooltip_competitors',
    element: AnalyticsTable
};
